var toString = require('../lang/toString');

    /**
     * Escape RegExp string chars.
     */
    function escapeRegExp(str) {
        return toString(str).replace(/\W/g,'\\$&');
    }

    module.exports = escapeRegExp;





//////////////////
// WEBPACK FOOTER
// ./~/mout/string/escapeRegExp.js
// module id = 1665
// module chunks = 0 1 2